import React from 'react'
import './Intro.css'
import Github from '../../img/github.png';
import Linkedin from '../../img/linkedin.png';
import Instagram from '../../img/instagram.png';
import Vector1 from '../../img/Vector1.png';
import Vector2 from '../../img/Vector2.png';
import Ravi3 from '../../img/Ravi3.png';
import thumbup from '../../img/thumbup.png';
import Crown from '../../img/crown.png';
import glassesimoji from '../../img/glassesimoji.png';
import FloatingDiv from '../FloatingDiv/FloatingDiv';
import { themeContext } from '../../Context';
import {Link} from 'react-scroll';
import { useContext } from 'react';
 const Intro=()=> {
  const theme = useContext(themeContext)
  const darkMode = theme.state.darkMode;
  return (
    <div className="intro">
      <div className="i-left">
        <div className="i-name">
          <span style={{color: darkMode? 'white': ''}}>Hi! I Am</span>
          <span>Ravi Tandan</span>
          <span>Frontend Developer with high level of
            experience in web designing and development,
            deliver quality based work</span>
        </div>
        <Link spy={true} to='Contact-form' smooth={true}>
        <button className="button i-button">Hire me</button>
        </Link>
        <div className="i-icons">
          <a href="https://github.com/RaviTandan"><img src={Github} alt="" /></a>
          <a href="https://www.linkedin.com/in/ravi-tandan-219090250"><img src={Linkedin} alt="" /></a>
          <a href="https://www.instagram.com/invites/contact/?i=1vlkm67667jey&utm_content=ibj3jb7"><img src={Instagram} alt="" /></a>
        </div>
      </div>
      <div className="i-right">
        <img src={Vector1} alt="" />
        <img src={Vector2} alt="" />
        <img src={Ravi3} alt="" />
        <img src={glassesimoji} alt=""/>
        <div style={{ top: '-4%', left: '68%' }}
        className="floating-div">
        <FloatingDiv image={Crown} txt1='Web' txt2='Developer' />
        </div>
        <div style={{top:'18rem' , left:'0rem'}} className="floating-div">
        <FloatingDiv image={thumbup} txt1='Best Design' txt2='Award' />
        </div>
        
        {/* Blure Div */}
        <div className="blur" style={{background:"rgba(238 210 255)"}}></div>
        <div className="blur" 
        style={{
          background:'#C1F5FF',
          top: '17rem',
          width: '21rem',
          height: '11rem',
          left: '-9rem'
        }}
        ></div>
      </div>
    </div>
  )
}

export default Intro
